module.exports = __webpack_public_path__ + "static/media/bell-desk1.489893cd.aac";